import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {AuthGuardService} from './auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'permit-app',
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    resolve:[AuthGuardService],
    loadChildren: () => import('./app-lander/app-lander.module').then(m => m.AppLanderModule)
  },
  {
    path: '',
    redirectTo: 'permit-app',
    pathMatch: 'full'
  },
  {path: '**', redirectTo: 'permit-app'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, relativeLinkResolution: 'legacy', preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
